/* eslint-disable sort-keys */
/* eslint-disable sort-keys-fix/sort-keys-fix */
/* eslint-disable max-lines */

import {
  FormFieldsetConfig,
  FormFieldsetSource,
} from 'src/app/@shared/form/form.types';
import { FormKey } from 'src/app/@shared/form/form-config';

const FORM_FIELDSET_META: FormFieldsetSource = {
  fieldIds: [
    'legacyId',
    'type',
    'subType',
    'subTypeForm',
    'searchForms',
  ],
  id: 'meta',
};

const FORM_FIELDSET_META_SECONDARY: FormFieldsetSource = {
  fieldIds: ['status', 'isPublished'],
};

const FORM_FIELDSET_TOPICS: FormFieldsetSource = {
  category: 'contact',
  fieldIds: ['topics', 'additionalTopics'],
};

const FORM_FIELDSET_TOPICS_FREE_TEXT: FormFieldsetSource = {
  category: 'contact',
  id: 'topics',
  type: 'dynamic',
  fieldIds: ['topicsFreeText'],
};

const FORM_FIELDSET_CONTACT: FormFieldsetSource = {
  category: 'contact',
  fieldIds: [
    'name',
    'shortName',
    'firstName',
    'lastName',
    'academicTitle',
    'contactViaNakos', // only visible for type5
    'addressCo',
    'addressStreetAndNumber',
    'addressPostalCode',
    'addressCity',
    'addressFederalState',
  ],
  id: 'contact',
};

const FORM_FIELD_SET_DYNAMIC: FormFieldsetSource = {
  category: 'contact',
  type: 'dynamic',
  fieldIds: [
    'phoneContacts',
    'emails',
    'emailsExtended',
    'phoneNumbers', // person only
    'websites',
    'socialMediaLinks',
  ],
};

const FORM_FIELDSET_CONTACT_PERSON_DYNAMIC: FormFieldsetSource = {
  category: 'contact',
  type: 'dynamic',
  fieldIds: ['contactPersons'],
};

const FORM_FIELDSET_WORKING_METHODS: FormFieldsetSource = {
  id: 'working_methods',
  fieldIds: ['workingMethod'],
};

const FORM_FIELDSET_NOTES: FormFieldsetSource = {
  category: 'contact',
  id: 'notes',
  fieldIds: ['notes'],
};

const FORM_FIELDSET_QUALIFICATIONS: FormFieldsetSource = {
  category: 'qualification',
  id: 'qualifications',
  fieldIds: ['qualifications'],
};

const FORM_FIELDSET_MEDIA: FormFieldsetSource = {
  category: 'all',
  id: 'media',
  fieldIds: ['media'],
};

const FORM_FIELDSETS_COMMON: FormFieldsetSource[] = [
  FORM_FIELDSET_META,
  FORM_FIELDSET_META_SECONDARY,
  FORM_FIELDSET_TOPICS_FREE_TEXT,
  FORM_FIELDSET_TOPICS,
  FORM_FIELDSET_CONTACT,
  FORM_FIELD_SET_DYNAMIC,
  FORM_FIELDSET_CONTACT_PERSON_DYNAMIC, // C/O-ORGANIZATION LIST WILL BE SHOWN AFTER CONTACT PERSONS
  // so here are c/o-organization information
  FORM_FIELDSET_NOTES,
];

// fieldIds which are not part of subtype form, are skipped automatically
// e.g. type 1d only has providesFor
const FORM_FIELDSETS_TYPE1: FormFieldsetSource[] = [
  ...FORM_FIELDSETS_COMMON,
  FORM_FIELDSET_WORKING_METHODS,
  {
    category: 'all',
    id: 'offices',
    fieldIds: ['isMainOffice', 'mainOffice', 'branchOffices'],
  },
  {
    category: 'all',
    fieldIds: ['coverageArea', 'requestsReceivedLastYear', 'numberOfCurrentlyAffiliatedGroups', 'foundingYear'],
  },
  {
    category: 'all',
    id: 'providers',
    fieldIds: ['providesFor', 'providedByRed', 'providedByOtherFreeText', 'providedByOther'],
  },
  {
    category: 'all',
    fieldIds: ['isBarrierFree'],
  },
  FORM_FIELDSET_QUALIFICATIONS,
  FORM_FIELDSET_MEDIA,
];

const FORM_FIELDSETS_TYPE2: FormFieldsetSource[] = [
  ...FORM_FIELDSETS_COMMON,
  {
    category: 'structure',
    id: 'structure',
    fieldIds: ['foundingYear', 'memberCount', 'headquarters', 'stateLevelSubdivisions'],
  },
  {
    category: 'structure',
    id: 'transparency',
    fieldIds: ['hasTransparencyLabel', 'transparencyPdfId', 'transparencyPdf'],
  },
  FORM_FIELDSET_QUALIFICATIONS,
  FORM_FIELDSET_MEDIA,
];

const FORM_FIELDSETS_TYPE3AND4: FormFieldsetSource[] = [
  ...FORM_FIELDSETS_COMMON,
  {
    category: 'structure',
    id: 'structure',
    fieldIds: [
      'groupStatus',
      'foundingYear',
      'memberCount',
      'coverageArea',
      'targetGroup',
      'description',
    ],
  },
  {
    category: 'structure',
    id: 'file_upload',
    fieldIds: ['fileId', 'file', 'source'],
  },
  {
    category: 'structure',
    fieldIds: [
      'meetingFormat',
      'meetingPostalCode',
      'meetingLocation',
      'toolUsed',
      'dataProtectionCompliant',
      'language',
    ],
  },
];

const FORM_FIELDSETS_TYPE3: FormFieldsetSource[] = [
  ...FORM_FIELDSETS_TYPE3AND4,
  {
    category: 'contact',
    id: 'contact_via',
    fieldIds: [
      'localContactPoint',
      'contactOrganizationFreeText',
      'contactOrganization',
      'providerFreeText',
      'provider',
    ],
  },
  FORM_FIELDSET_QUALIFICATIONS,
  FORM_FIELDSET_MEDIA,
];

const FORM_FIELDSETS_TYPE4: FormFieldsetSource[] = [
  ...FORM_FIELDSETS_TYPE3AND4,
  {
    category: 'contact',
    id: 'contact_via',
    fieldIds: ['localContactPoint', 'contactOrganizationFreeText', 'contactOrganization'],
  },
  FORM_FIELDSET_QUALIFICATIONS,
  FORM_FIELDSET_MEDIA,
];

const FORM_FIELDSETS_TYPE5: FormFieldsetSource[] = [
  ...FORM_FIELDSETS_COMMON,
  {
    category: 'detail',
    id: 'explanation',
    fieldIds: ['problemExplanation'],
  },
  {
    category: 'detail',
    fieldIds: ['specificIssues'],
  },
  {
    category: 'detail',
    fieldIds: ['affectedPerson', 'dateOfBirth'],
  },
  {
    category: 'detail',
    fieldIds: ['interestedInfos', 'experienceExchangeTopics', 'foundingInterests', 'contactInterests'],
  },
  FORM_FIELDSET_QUALIFICATIONS,
  FORM_FIELDSET_MEDIA,
];

const FORM_FIELDSETS_TYPE6: FormFieldsetSource[] = [...FORM_FIELDSETS_COMMON, FORM_FIELDSET_QUALIFICATIONS, FORM_FIELDSET_MEDIA];

const FORM_FIELDSETS_TYPE7: FormFieldsetSource[] = [
  ...FORM_FIELDSETS_COMMON,
  {
    category: 'all',
    fieldIds: ['providesFor'],
  },
  FORM_FIELDSET_QUALIFICATIONS,
  FORM_FIELDSET_MEDIA,
];

const FORM_FIELDSETS_TYPE8: FormFieldsetSource[] = [...FORM_FIELDSETS_COMMON, FORM_FIELDSET_QUALIFICATIONS, FORM_FIELDSET_MEDIA];

const FORM_FIELDSET_TOPICS_FORM: FormFieldsetSource[] = [
  {
    id: 'meta',
    category: 'all',
    fieldIds: ['legacyId'],
  },
  {
    id: 'name',
    category: 'all',
    fieldIds: ['title'],
  },
  {
    category: 'all',
    fieldIds: ['synonyms'],
    type: 'dynamic',
  },
  {
    id: 'english_name',
    category: 'all',
    fieldIds: ['englishTitle'],
  },
  {
    id: 'general',
    category: 'all',
    fieldIds: ['sector', 'area', 'domain', 'notes'],
  },
  {
    category: 'all',
    fieldIds: ['links'],
    type: 'dynamic',
  },
  {
    id: 'icd',
    category: 'icd',
    fieldIds: ['icdArea', 'icdGroup'],
  },
  {
    category: 'icd',
    fieldIds: ['icd10Codes'],
    type: 'dynamic',
  },
  {
    category: 'icd',
    fieldIds: ['icd11Codes'],
    type: 'dynamic',
  },
  {
    id: 'orphanet',
    category: 'orphanet',
    fieldIds: ['isRareDisease', 'orphanetTopicName', 'orphanetTopicId'],
  },
  {
    category: 'orphanet',
    fieldIds: ['orphanetSynonyms'],
    type: 'dynamic',
  },
];

const FORM_FIELDSET_TOPICS_FILTER_FORM: FormFieldsetSource[] = [
  {
    id: 'general',
    category: 'all',
    fieldIds: ['isRareDisease', 'sector', 'area', 'domain'],
  },
  {
    id: 'icd',
    category: 'icd',
    fieldIds: ['icdArea', 'icdGroup', 'icd10Codes', 'icd11Codes'],
  },
];

const FORM_FIELDSET_CLUSTER_FORM: FormFieldsetSource[] = [
  {
    fieldIds: ['title', 'notes'],
  },
  {
    fieldIds: ['isSmartCluster'],
  },
  {
    fieldIds: ['includeSelfHelpAddresses'],
  },
  {
    fieldIds: ['includeOtherAddresses'],
  },
  {
    fieldIds: ['includePersons'],
  },
  {
    fieldIds: ['includeContactPersons'],
  },
  {
    fieldIds: ['includeTopics'],
  },
  {
    fieldIds: [
      'selfHelpAddresses',
      'otherAddresses',
      'persons',
      'contactPersons',
      'topics',
    ],
  },
];

const FORM_FIELDSET_ORGANIZATION_FILTER_FORM: FormFieldsetSource[] = [
  {
    fieldIds: [
      'subType',
      'subTypeForm',
      'searchForms',
      'status',
      'topics',
      'addressPostalCode',
      'addressFederalState',
      'isPublished',
      'hasTransparencyLabel',
      'stateLevelSubdivisions',
      'targetGroup',
      'language',
      'qualifications',
      'media',
    ],
  },
];

const FORM_FIELDSET_PUBLIC_FILTER_FORM: FormFieldsetSource[] = [
  {
    fieldIds: [
      'subType',
      'subTypeForm',
      'addressFederalState',
      'hasTransparencyLabel',
      'stateLevelSubdivisions',
      'targetGroup',
      'language',
    ],
  },
];

const FORM_FIELDSET_USER_FORM: FormFieldsetSource[] = [
  {
    id: 'name',
    fieldIds: ['firstname', 'lastname', 'alias'],
  },
  {
    id: 'general',
    fieldIds: ['email', 'roles'],
  },
  {
    fieldIds: ['notes'],
    id: 'notes',
  },
];

export const FORM_FIELDSET_CONFIG: { [key in FormKey]?: FormFieldsetConfig } = {
  selfHelpAddress: [
    {
      fieldIds: ['type', 'subType', 'subTypeForm'],
    },
  ],
  selfHelpAddressRa1a: FORM_FIELDSETS_TYPE1,
  selfHelpAddressRa1b: FORM_FIELDSETS_TYPE1,
  selfHelpAddressRa1c: FORM_FIELDSETS_TYPE1,
  selfHelpAddressRa1d: FORM_FIELDSETS_TYPE1,
  selfHelpAddressGa2a: FORM_FIELDSETS_TYPE2,
  selfHelpAddressGa2b: FORM_FIELDSETS_TYPE2,
  selfHelpAddressGa2c: FORM_FIELDSETS_TYPE2,
  selfHelpAddressGa2d: FORM_FIELDSETS_TYPE2,
  selfHelpAddressCommunity3a: FORM_FIELDSETS_TYPE3,
  selfHelpAddressCommunity3b: FORM_FIELDSETS_TYPE3,
  selfHelpAddressCommunity3c: FORM_FIELDSETS_TYPE3,
  selfHelpAddressShGroup4a: FORM_FIELDSETS_TYPE4,
  selfHelpAddressShGroup4b: FORM_FIELDSETS_TYPE4,
  selfHelpAddressShGroup4c: FORM_FIELDSETS_TYPE4,
  selfHelpAddressBa: FORM_FIELDSETS_TYPE5,
  selfHelpAddressOther: FORM_FIELDSETS_TYPE6,
  otherAddress: FORM_FIELDSETS_TYPE7,
  person: FORM_FIELDSETS_TYPE8,
  topic: FORM_FIELDSET_TOPICS_FORM,
  filterOrganization: FORM_FIELDSET_ORGANIZATION_FILTER_FORM,
  filterPublicOrganization: FORM_FIELDSET_PUBLIC_FILTER_FORM,
  filterTopic: FORM_FIELDSET_TOPICS_FILTER_FORM,
  cluster: FORM_FIELDSET_CLUSTER_FORM,
  user: FORM_FIELDSET_USER_FORM,
};
